import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: ('superadmin' | 'admin')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  // Check localStorage for authentication
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userRole = localStorage.getItem('userRole') as 'superadmin' | 'admin' | null;
  const authToken = localStorage.getItem('authToken');

  // Validate token exists and is not empty
  const hasValidToken = authToken && authToken.trim() && 
                       authToken !== 'null' && 
                       authToken !== 'undefined' &&
                       !authToken.startsWith('[object');

  console.log('🔐 ProtectedRoute Check:', {
    isAuthenticated,
    userRole,
    hasToken: !!authToken,
    hasValidToken,
    tokenLength: authToken?.length || 0,
    allowedRoles,
    timestamp: new Date().toISOString(),
    localStorageKeys: Object.keys(localStorage).filter(k => k.includes('auth') || k.includes('token') || k.includes('role'))
  });

  // If not authenticated or no valid token, redirect to login
  if (!isAuthenticated || !hasValidToken) {
    console.log('❌ Not authenticated or invalid token - redirecting to login');
    // Clear any stale data
    if (!hasValidToken) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userEmail');
    }
    return <Navigate to="/admin/login" replace />;
  }

  // If authenticated but role not allowed, redirect to appropriate dashboard
  if (userRole && !allowedRoles.includes(userRole)) {
    console.log('❌ Role not allowed - redirecting');
    if (userRole === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (userRole === 'superadmin') {
      return <Navigate to="/super-admin/profile" replace />;
    }
  }

  console.log('✅ Access granted');
  // If authenticated and role is allowed, render children
  return <>{children}</>;
};

export default ProtectedRoute;

